/*
 * @Description:
 * @Date: 2025-07-07 13:50:31
 */
export const ENABLE = {
  0: {
    label: '停用',
    value: 0
  },
  1: {
    label: '启用',
    value: 1
  },
  2: {
    label: '已注销',
    value: 2
  }
};
// 个体户证照状态
export const LICENSE_AUDIT_STATUS = {
  11: {
    label: '平台审核中',
    value: 11
  },
  13: {
    label: '平台驳回',
    value: 13
  },
  14: {
    label: '平台终止',
    value: 14
  },
  21: {
    label: '园区审核中',
    value: 21
  },
  23: {
    label: '园区驳回',
    value: 23
  },
  24: {
    label: '园区终止',
    value: 24
  },
  22: {
    label: '成功',
    value: 22
  }
};
export const INDIVIDUAL_TYPE = {
  2: {
    label: '客户个体户',
    value: 2
  },
  3: {
    label: '园区个体户',
    value: 3
  }
};
export const SOURCE = {
  1: {
    label: '终端',
    value: 1
  },
  2: {
    label: '导入',
    value: 2
  }
};
// 个体户认证状态
export const INDIVIDUAL_AUTH_STATUS = {
  0: {
    label: '未认证',
    value: 0
  },
  1: {
    label: '认证中',
    value: 1
  },
  2: {
    label: '认证通过',
    value: 2
  },
  3: {
    label: '认证失败',
    value: 3
  }
};
export const ENTP_CERT_TYPE = {
  1: {
    label: '统一社会信用码',
    value: 1
  },
  2: {
    label: '工商注册号',
    value: 2
  }
};
export const OPERA_TYPE = {
  1: {
    label: '自动开启（富友开通成功）',
    value: 1
  },
  2: {
    label: '自动开启（人脸识别成功）',
    value: 2
  },
  3: {
    label: '自动开启（手动提现成功）',
    value: 3
  },
  4: {
    label: '系统自动关闭',
    value: 4
  },
  5: {
    label: '手动开始',
    value: 5
  },
  6: {
    label: '手动关闭',
    value: 6
  },
  7: {
    label: '人脸识别关闭',
    value: 7
  }
};
export const TAX_ASSESSMENT_METHOD = {
  1: {
    label: '核定',
    value: 1
  },
  2: {
    label: '查账',
    value: 2
  },
  3: {
    label: '定期定额',
    value: 3
  }
};
export const DECLARE_METHOD = {
  1: {
    label: '月度',
    value: 1
  },
  2: {
    label: '季度',
    value: 2
  }
};
export const INVOICE_TYPE = {
  1: {
    label: '增值税专用发票',
    value: 1
  },
  2: {
    label: '增值税普通发票',
    value: 2
  },
  3: {
    label: '全选',
    value: 3
  }
};
export const TERMINATE = [
  {
    label: '法人身份信息原因',
    value: '法人身份信息原因'
  },
  {
    label: '园区暂停入驻设立',
    value: '园区暂停入驻设立'
  },
  {
    label: '客户取消入驻设立',
    value: '客户取消入驻设立'
  }
];
export const ENTER_TYPE = ['platformAudit', 'parkAudit', 'detail'] as const; // platform平台审核 park园区审核 detail查看详情
